export default "__VITE_ASSET__726377b5__"